var map = {
	"./Icon.js": 258,
	"./IconAcademy.js": 292,
	"./IconAddWatchlist.js": 293,
	"./IconAddedWatchlist.js": 294,
	"./IconAlert.js": 295,
	"./IconArrowDouble.js": 296,
	"./IconArrowDown.js": 297,
	"./IconArrowDownBig.js": 298,
	"./IconArrowLeft.js": 299,
	"./IconArrowLeftBig.js": 300,
	"./IconArrowRight.js": 301,
	"./IconArrowRightBig.js": 302,
	"./IconArrowRightSmall.js": 303,
	"./IconArrowUp.js": 304,
	"./IconArrowUpBig.js": 305,
	"./IconAssetSmall.js": 306,
	"./IconAssets.js": 307,
	"./IconBadge.js": 308,
	"./IconBell.js": 309,
	"./IconBellOff.js": 310,
	"./IconBulletList.js": 311,
	"./IconCalendar.js": 312,
	"./IconCalendarSmall.js": 313,
	"./IconChange.js": 314,
	"./IconChart.js": 315,
	"./IconChartBars.js": 316,
	"./IconChartLayout.js": 317,
	"./IconChartLine.js": 318,
	"./IconCheckmark.js": 319,
	"./IconClock.js": 320,
	"./IconClockSmall.js": 321,
	"./IconClose.js": 322,
	"./IconCloseMedium.js": 323,
	"./IconCloseSmall.js": 324,
	"./IconCloudBig.js": 325,
	"./IconCloudSmall.js": 326,
	"./IconColumns.js": 327,
	"./IconComment.js": 328,
	"./IconCommentSmall.js": 329,
	"./IconCompare.js": 330,
	"./IconConnection.js": 331,
	"./IconConnectionBig.js": 332,
	"./IconConnectionSmall.js": 333,
	"./IconCopy.js": 334,
	"./IconCrown.js": 335,
	"./IconCrownBig.js": 336,
	"./IconCustomize.js": 337,
	"./IconDisk.js": 338,
	"./IconDiskSmall.js": 339,
	"./IconDots.js": 340,
	"./IconDotsSmall.js": 341,
	"./IconDotsVertical.js": 342,
	"./IconEdit.js": 343,
	"./IconEditSmall.js": 344,
	"./IconEnvelope.js": 345,
	"./IconError.js": 346,
	"./IconExternalLink.js": 347,
	"./IconEye.js": 348,
	"./IconEyeDisabled.js": 349,
	"./IconEyeDisabledSmall.js": 350,
	"./IconEyeSmall.js": 351,
	"./IconFacebook.js": 352,
	"./IconFilter.js": 353,
	"./IconFilterFilled.js": 354,
	"./IconFilterSmall.js": 355,
	"./IconFinance.js": 356,
	"./IconFire.js": 357,
	"./IconFireFilled.js": 358,
	"./IconFlash.js": 359,
	"./IconFlashFilled.js": 360,
	"./IconFolder.js": 361,
	"./IconFollow.js": 362,
	"./IconFollowers.js": 363,
	"./IconFollowing.js": 364,
	"./IconFullscreen.js": 365,
	"./IconFullscreenArrows.js": 366,
	"./IconHamburger.js": 367,
	"./IconHelpRound.js": 368,
	"./IconHide.js": 369,
	"./IconHistoryClear.js": 370,
	"./IconInfoRound.js": 371,
	"./IconInfoRoundSmall.js": 372,
	"./IconInsight.js": 373,
	"./IconInterval.js": 374,
	"./IconLike.js": 375,
	"./IconLikeSmall.js": 376,
	"./IconLink.js": 377,
	"./IconLinkedIn.js": 378,
	"./IconLock.js": 379,
	"./IconLockSmall.js": 380,
	"./IconLogout.js": 381,
	"./IconMail.js": 382,
	"./IconMailSmall.js": 383,
	"./IconMerge.js": 384,
	"./IconMetamask.js": 385,
	"./IconMetamaskMonochrome.js": 386,
	"./IconPause.js": 387,
	"./IconPauseRound.js": 388,
	"./IconPicture.js": 389,
	"./IconPlay.js": 390,
	"./IconPlayRound.js": 391,
	"./IconPlus.js": 392,
	"./IconPlusRound.js": 393,
	"./IconPlusRoundSmall.js": 394,
	"./IconPlusSmall.js": 395,
	"./IconPointerRight.js": 396,
	"./IconPointerRightSmall.js": 397,
	"./IconProfile.js": 398,
	"./IconProfileSmall.js": 399,
	"./IconQuestionRound.js": 400,
	"./IconQuestionRoundSmall.js": 401,
	"./IconQuote.js": 402,
	"./IconReddit.js": 403,
	"./IconRefresh.js": 404,
	"./IconRemove.js": 405,
	"./IconRemoveSmall.js": 406,
	"./IconReport.js": 407,
	"./IconRevert.js": 408,
	"./IconRing.js": 409,
	"./IconSave.js": 410,
	"./IconSearch.js": 411,
	"./IconSearchSmall.js": 412,
	"./IconSettings.js": 413,
	"./IconSettingsBig.js": 414,
	"./IconShare.js": 415,
	"./IconSidebar.js": 416,
	"./IconSigma.js": 417,
	"./IconSignal.js": 418,
	"./IconSocial.js": 419,
	"./IconSubtractRound.js": 420,
	"./IconSuccessRound.js": 421,
	"./IconTelegram.js": 422,
	"./IconTextBig.js": 423,
	"./IconTextBold.js": 424,
	"./IconTextItalic.js": 425,
	"./IconTextSmall.js": 426,
	"./IconTextUnderline.js": 427,
	"./IconTriangleBoth.js": 428,
	"./IconTriangleDown.js": 429,
	"./IconTriangleRight.js": 430,
	"./IconTriangleUp.js": 431,
	"./IconTwitter.js": 432,
	"./IconUpDown.js": 433,
	"./IconUpdate.js": 434,
	"./IconViewOption.js": 435,
	"./IconWallet.js": 436,
	"./IconWarning.js": 437,
	"./IconWordsList.js": 438,
	"./iconTag.js": 439,
	"./index.js": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;